const planList = () => import("@/pages/plan/list/index.vue");
const planListForm = () => import("@/pages/plan/list/form.vue");
const planListDetail = () => import("@/pages/plan/list/detail.vue");

export default [
    {
        path: "/plan/list",
        component: planList,
        meta: [
            {
                name: "方案管理",
                activeRoute: "/plan/manage",
            },
            {
                name: "方案列表",
                activeRoute: "/plan/list",
            },
        ],
    },
    {
        path: "/plan/list/form",
        component: planListForm,
        meta: [
            {
                name: "方案管理",
                activeRoute: "/plan/manage",
            },
            {
                name: "方案列表",
                url: "/plan/list",
            },
            {
                name: "新增/编辑",
                activeRoute: "/plan/list",
            },
        ],
    },
    {
        path: "/plan/list/detail",
        component: planListDetail,
        meta: [
            {
                name: "方案管理",
                activeRoute: "/plan/manage",
            },
            {
                name: "方案列表",
                url: "/plan/list",
            },
            {
                name: "详情",
                activeRoute: "/plan/list",
            },
        ],
    },
];
